export default "__VITE_ASSET__955f325a__"